function initializeBlogsCarouselNavigation() {
  const container = document.querySelector(".home-page-blogs-section__blogs-container");
  const prevBtn = document.querySelector(".home-page-blogs-section__nav-btn--prev");
  const nextBtn = document.querySelector(".home-page-blogs-section__nav-btn--next");
  const dotsContainer = document.querySelector(".home-page-blogs-section__nav-dots");
  if (!container || !prevBtn || !nextBtn) return;

  const items = container.querySelectorAll(".home-page-blogs-section__blog");

  if (dotsContainer && items.length > 0) {
    items.forEach((_, i) => {
      const dot = document.createElement("button");
      dot.classList.add("home-page-blogs-section__nav-dot");
      dot.setAttribute("aria-label", `Go to item ${i + 1}`);
      if (i === 0) dot.classList.add("active");
      dot.addEventListener("click", () => {
        container.scrollTo({ left: i * getScrollAmount(), behavior: "smooth" });
      });
      dotsContainer.appendChild(dot);
    });
  }

  function getScrollAmount() {
    const firstItem = container.querySelector(".home-page-blogs-section__blog");
    if (!firstItem) return 0;
    const gap = parseFloat(getComputedStyle(container).columnGap) || 0;
    return firstItem.offsetWidth + gap;
  }

  function getActiveIndex() {
    const amount = getScrollAmount();
    return amount > 0 ? Math.round(container.scrollLeft / amount) : 0;
  }

  function updateButtons() {
    const atStart = container.scrollLeft <= 1;
    const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;
    prevBtn.classList.toggle("active", !atStart);
    nextBtn.classList.toggle("active", !atEnd);
  }

  function updateDots() {
    if (!dotsContainer) return;
    const dots = dotsContainer.querySelectorAll(".home-page-blogs-section__nav-dot");
    const activeIndex = getActiveIndex();
    dots.forEach((dot, i) => dot.classList.toggle("active", i === activeIndex));
  }

  prevBtn.addEventListener("click", () => {
    container.scrollBy({ left: -getScrollAmount(), behavior: "smooth" });
  });

  nextBtn.addEventListener("click", () => {
    container.scrollBy({ left: getScrollAmount(), behavior: "smooth" });
  });

  container.addEventListener("scroll", updateButtons, { passive: true });
  container.addEventListener("scroll", updateDots, { passive: true });

  updateButtons();
  updateDots();
}

document.addEventListener("DOMContentLoaded", initializeBlogsCarouselNavigation);
